<nz-radio-group class="iconed-radio max-w-full flex flex-wrap" nzButtonStyle="solid" [(ngModel)]="value"
                [nzDisabled]="disabled">
  <ng-container *ngFor="let option of options | async">
    <label
      nz-radio-button
      class="iconed-radio__label"
      [nzValue]="option.value"
    >
      <div class="iconed-radio__label-inner">
        <i class="text-[36px]" [ngClass]="'icon-' + option.icon"></i>
        <span class="iconed-radio__label-text">{{ option.label | translate }}</span>
      </div>
    </label>
  </ng-container>
</nz-radio-group>
